import React from 'react';
import clsx from 'clsx';

const variants = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  tertiary: 'btn-tertiary',
  danger: 'btn-danger',
  ghost: 'btn-ghost',
  dark: 'btn-dark',
};

const sizes = {
  sm: 'btn-sm',
  md: '',
  lg: 'btn-lg',
};

export const Button = React.forwardRef(function Button(
  { children, variant = 'primary', size = 'md', className, loading, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      className={clsx('btn', variants[variant], sizes[size], 'focus-ring', className)}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && (
        <svg className="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {children}
    </button>
  );
});

export default Button;

export const IconButton = React.forwardRef(function IconButton({ children, className, ...props }, ref) {
  return (
    <button
      ref={ref}
      className={clsx(
        'inline-flex items-center justify-center p-2 transition-colors focus-ring',
        'min-w-[44px] min-h-[44px]',
        className
      )}
      style={{ color: 'var(--color-text-secondary)' }}
      {...props}
    >
      {children}
    </button>
  );
});
